import { useState } from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle, CheckCircle, Loader2 } from 'lucide-react';
import { getApiUrl } from '../../utils/api';

const ResetPasswordPage = () => {
    const [username, setUsername] = useState('');
    const [message, setMessage] = useState(null);
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage(null);
        try {
            const res = await fetch(`${getApiUrl()}/users/requestpassword`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username }),
            });
            const data = await res.json().catch(() => ({}));
            setSuccess(res.ok && data.success === true);
            setMessage(data.message || 'Something went wrong. Please try again.');
        } catch {
            setSuccess(false);
            setMessage('Unable to connect. Please check your connection and try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary to-primary-dark p-4">
            <div className="w-full max-w-sm bg-white rounded-2xl shadow-modal p-8 md:p-10">
                <div className="text-center mb-6">
                    <img src="/nhclogo.png" alt="National HealthClaim" className="h-16 w-auto mx-auto" />
                    <div className="text-xs font-semibold tracking-widest text-gray-500 mt-2 uppercase">Sales Portal</div>
                </div>

                <h2 className="text-center text-lg font-semibold text-gray-900 mb-6">Reset your password</h2>

                {message && success && (
                    <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-xl text-green-600 text-sm flex items-center gap-2">
                        <CheckCircle className="w-4 h-4 flex-shrink-0" /><span>{message}</span>
                    </div>
                )}

                {message && !success && (
                    <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl text-red-600 text-sm flex items-center gap-2">
                        <AlertCircle className="w-4 h-4 flex-shrink-0" /><span>{message}</span>
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="mb-6">
                        <label className="block text-sm font-medium text-gray-700 mb-2">Username</label>
                        <input type="text" name="username" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Enter your username" required
                            className="w-full p-4 border border-gray-200 rounded-xl text-base text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/10 transition-all duration-200" />
                    </div>
                    <button type="submit" disabled={loading}
                        className="w-full bg-primary text-white py-4 px-6 rounded-full font-semibold text-base shadow-sm hover:bg-primary-dark active:scale-[0.98] transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2">
                        {loading && <Loader2 className="w-5 h-5 animate-spin" />}
                        {loading ? 'Submitting...' : 'Submit'}
                    </button>
                </form>

                <Link to="/signin" className="block mt-4 text-center text-sm text-primary hover:text-primary-dark transition-colors">
                    Return to login
                </Link>
            </div>
        </div>
    );
};

export default ResetPasswordPage;
